import React from "react";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false,
      error: null,
      errorInfo: null,
    };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error("ErrorBoundary caught an error", error, errorInfo);
    this.setState({ errorInfo });
  }

  handleReset = () => {
    // Simpel reset – reloader hele siden, så du er tilbage ved “clean state”
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      return (
        <div
          style={{
            minHeight: "100vh",
            background: "#0b1120",
            color: "#f97316",
            padding: "24px",
            fontFamily:
              "system-ui, -apple-system, BlinkMacSystemFont, sans-serif",
          }}
        >
          <h1 style={{ fontSize: "24px", marginBottom: "12px" }}>
            Something went wrong in the app
          </h1>
          <p style={{ marginBottom: "16px" }}>
            The UI crashed while rendering the result. This is a React runtime
            error – not your browser and not the API.
          </p>
          {this.state.error && (
            <pre
              style={{
                background: "#020617",
                color: "#facc15",
                padding: "12px",
                borderRadius: "8px",
                fontSize: "13px",
                overflowX: "auto",
                marginBottom: "12px",
              }}
            >
              {this.state.error.toString()}
            </pre>
          )}
          {this.state.errorInfo && (
            <details
              style={{
                whiteSpace: "pre-wrap",
                background: "#020617",
                color: "#e5e7eb",
                padding: "12px",
                borderRadius: "8px",
                fontSize: "12px",
              }}
            >
              {this.state.errorInfo.componentStack}
            </details>
          )}
          <button
            onClick={this.handleReset}
            style={{
              marginTop: "16px",
              padding: "8px 16px",
              borderRadius: "9999px",
              border: "none",
              cursor: "pointer",
              background: "#f97316",
              color: "#0b1120",
              fontWeight: 600,
            }}
          >
            Reload app
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
